import { MODELS, getDecision, getTests, getFilterSet, getOffer, getSource } from '@/data/catalogue';

export interface EditorialRow { id: string; name: string; state: string; flags: string[] }

const daysBetween = (iso: string, now: Date) => Math.floor((now.getTime() - new Date(iso + 'T00:00:00Z').getTime()) / 86400000);

/** Flags only — never changes a record. */
export function buildEditorialReport(now: Date) {
  const rows: EditorialRow[] = MODELS.map((m) => {
    const d = getDecision(m.id);
    const flags: string[] = [];
    if (d?.state === 'held') flags.push(`Held: ${d.reason}`);
    d?.conflicts.forEach((c) => flags.push(`Conflict: ${c}`));
    const offer = getOffer(m.id);
    if (offer) {
      const age = daysBetween(offer.observed, now);
      if (age > 7) flags.push(`Price/link last checked ${age} days ago (weekly cadence).`);
      if (offer.stock !== 'in-stock') flags.push(`Offer stock: ${offer.stock}.`);
    } else if (d?.state !== 'archived') flags.push('No US offer recorded.');
    const fs = getFilterSet(m.id);
    if (d?.state !== 'archived') {
      if (!fs) flags.push('No filter record.');
      else {
        if (fs.priceUsd == null) flags.push('Filter price unknown.');
        if (fs.cycleMonths == null) flags.push('Filter interval unknown.');
        if (fs.availability !== 'in-stock') flags.push(`Filter availability: ${fs.availability}.`);
        if (fs.observed && daysBetween(fs.observed, now) > 31) flags.push('Filter availability older than a month.');
      }
      if (m.ratedPowerW == null) flags.push('Power draw unknown.');
      if (!getTests(m.id).some((t) => t.noiseDbA != null)) flags.push('No output-at-noise measurement.');
    }
    for (const t of getTests(m.id)) {
      const s = getSource(t.sourceId);
      if (s && s.checked !== 'source-checked') flags.push(`${t.metric} figure from ${s.checked.replace(/-/g, ' ')} — needs a fresh source check.`);
      if (s && daysBetween(s.accessed, now) > 92) flags.push(`${t.metric} specification older than a quarter.`);
    }
    return { id: m.id, name: `${m.brand} ${m.name}`, state: d?.state ?? 'unknown', flags: [...new Set(flags)] };
  });
  const counts = {
    Eligible: rows.filter((r) => r.state === 'eligible').length,
    Held: rows.filter((r) => r.state === 'held').length,
    Archived: rows.filter((r) => r.state === 'archived').length,
    'Records with flags': rows.filter((r) => r.flags.length).length,
  };
  return { rows, counts };
}
